import PropTypes from 'prop-types'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import ErrorIcon from '@mui/icons-material/Error'

import './displayError.scss'

const DisplayError = ({
  icon = <ErrorIcon />,
  title = 'Sorry, this is an invalid Report URL.',
  message = <p>There was an error completing your request.</p>,
  buttonLabel = 'Reload Page',
  onClick,
  withButton = true
}) => (
  <Container maxWidth='sm' className='display-error' data-testid='display-error'>
    <div className='display-error__icon'>{icon}</div>
    <Typography variant='h3' className='bold' data-testid='display-error--title'>
      {title}
    </Typography>
    <Typography variant='h6' data-testid='display-error--message'>
      {message}
    </Typography>
    {
      withButton && (
        <Button
          variant='contained'
          color='primary'
          onClick={onClick}
          className='display-error__button'
          data-testid='display-error__button'
        >
          {buttonLabel}
        </Button>
      )
    }
  </Container>
)

DisplayError.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  buttonLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  onClick: PropTypes.func,
  withButton: PropTypes.bool
}

export default DisplayError
